<div class="content">
  <i (click)="onCloseModal()" (keypress)="onCloseModal()" class="icon-cerrar"></i>
  <i class="icon-alert1"></i>
  <span class="title">{{ errorMessage }}</span>
  <p class="info">{{ 'errorModal.info' | transloco }}</p>
  <sl-button class="button" (clicked)="onCloseModal()" [label]="'errorModal.button' | transloco" [type]="'primary'"></sl-button>
</div>
